import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "stack_svg__svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M23 7 12 1 1 7l11 6 11-6Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M3.75 10.5 1 12l11 6 11-6-2.75-1.5L12 15l-8.25-4.5Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M3.75 15.5 1 17l11 6 11-6-2.75-1.5L12 20l-8.25-4.5Z"
    }, null, -1)
  ]))]))
}
export default { render: render }